import { BANNED_LOCATION_TITLES } from '../constants'
import { getLocationPartsTitles } from './getLocationPartsTitles'
import { Location } from '../../../types/models/Location.model'

export const getLocationPartsTitlesWithoutBannedLocations = (
  location: Location
): string[] => {
  const locationPartsTitles = getLocationPartsTitles(location)

  return locationPartsTitles.filter(
    (title) => !BANNED_LOCATION_TITLES.has(title)
  )
}
